<script>
import appConfig from "@/app.config";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {
          title: "",
          abstract: "",
          cover: "",
          logo: "",
        };
      },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    };
  },
  methods: {
    getImgUrl(img) {
      img = encodeURI(img);
      if (img) {
        if (img.indexOf("http") > -1) {
          return img;
        }
        return this.assetsPath + "images/" + img;
      }
      return "";
    },
    getGame(route) {
      return this.GLOBAL.hrefLink(`games/${route}`);
    },
  },
};
</script>

<template>
  <a href="javascript:" :class="$style.anchor">
    <div :class="$style.gameCard" class="d-flex flex-column">
      <div
        :class="[
          $style.cover,
          data.coverSize ? $style[data.coverSize] : $style.lg,
        ]"
        class="w-100"
      >
        <div
          :class="$style.coverBg"
          :style="{ 'background-image': 'url(' + getImgUrl(data.cover) + ')' }"
        />

        <div :class="$style.gameLogo">
          <img :src="getImgUrl(data.logo)" />
        </div>
      </div>
      <div
        :class="$style.content"
        class="px-lg-4 px-md-3 px-sm-3 px-3 text-center d-inline-block"
      >
        <h3 :class="$style.recomTitle">{{ data.title }}</h3>
        <p>{{ data.abstract }}</p>
        <!-- <div class="d-inline-block w-100">
          <a
            :href="getGame(data.route)"
            class="btn btn-info btn-lg rounded-half"
          >
            {{ $t("recommendations.learn") }}
          </a>
        </div> -->
      </div>
    </div>
  </a>
</template>

<style lang="scss" module>
@import "@/design/index.scss";
.anchor {
  text-decoration: none !important;
  display: inline-block;
  width: 100%;
  margin-bottom: 2px;
  padding-right: 2px;
  padding-left: 2px;
}
.recomTitle {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.gameCard {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background-color: $white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  .cover {
    position: relative;
    &.lg {
      height: 200px;
    }
    &.md {
      height: 150px;
    }
  }
  .coverBg {
    background-image: url("#{$assetsPath}images/game-cover-1@2x.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: inline-block;
    width: 100%;
    height: 100%;
    transition: 0.3s;
  }
  .gameLogo {
    position: absolute;
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 14px;
    left: 0;
    right: 0;
    bottom: -40px;
    margin: 0 auto;
  }
  .content {
    padding-top: 70px;
    padding-bottom: 40px;
    h3 {
      margin-bottom: 20px;
      font-size: 22px;
      color: #212529;
    }
    p {
      margin-bottom: 30px;
      font-size: 17px;
      color: #212529;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
@media only screen and (max-width: 767px) {
  .gameCard {
    .cover {
      &.lg {
        height: 150px;
      }
      &.md {
        height: 150px;
      }
    }
    .content {
      h3 {
        font-size: 20px;
      }
      p {
        padding: 0 10px;
      }
    }
  }
}
</style>
